import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'cursor.net.roi',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'cursor.hours.saved',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'estimated.cursor.cost',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'total.cursor.events',
                        },
                      },
                    },
                    span: 3,
                  },
                ],
              },
            },
            height: 200,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'net.roi.by.project',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'recent.value.creating.events',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 600,
          },
        ],
      },
    },
    description: 'Overview of Cursor usage, hours saved, cost, and ROI.',
    name: 'Cursor Tracker Dashboard',
    variables: [
      {
        id: 'projectId',
        name: 'Project ID',
        type: {
          dimensionId: 'dim::!projects',
          isMultiselect: true,
        },
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
